import React from 'react'

const ThumbsupIcon = () => {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.31607 21.7956 0 21 0ZM7.59259 11.7407H5V19H7.59259V11.7407ZM8.62963 19H15.8889C16.8511 18.9986 17.7735 18.6158 18.4539 17.9354C19.1343 17.255 19.5171 16.3326 19.5185 15.3704V11.7407C19.5178 11.1909 19.2991 10.6637 18.9103 10.2749C18.5215 9.88609 17.9943 9.66735 17.4444 9.66667H13.2963V6.55556C13.2959 6.14312 13.1319 5.7477 12.8402 5.45607C12.5486 5.16443 12.1532 5.00041 11.7407 5H11.6723C11.4229 5.00093 11.1821 5.09129 10.9936 5.25465C10.8051 5.418 10.6815 5.64354 10.6451 5.8903L10.207 8.95837L8.62963 11.3244V19Z" fill="#A2ABB3" />
            </svg>

        </div>
    )
}

export default ThumbsupIcon
